// extracted by mini-css-extract-plugin
module.exports = {"active":"_2-KjI","dark":"_3I0To"};